import { render, staticRenderFns } from "./GlobalCalendarPage.vue?vue&type=template&id=32335e78&scoped=true&"
import script from "./GlobalCalendarPage.vue?vue&type=script&lang=js&"
export * from "./GlobalCalendarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32335e78",
  null
  
)

export default component.exports